module.exports = __webpack_public_path__ + "img/bird-comp.5825f255.png";